import React, { useEffect, useState } from "react";
import { Container, Box, Typography, TextField } from "@mui/material";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import { useTheme } from "@emotion/react";

export default function IntroSection() {
  const theme = useTheme();

  return (
    <>
    <Grid container sx={{ justifyContent: "center", position: "relative" }}>
      <Grid item md={6} sm={6}></Grid>
      <Grid item md={5} sm={5} sx={{ justifyContent: "center" }}>
        <img
          style={{
            width: "100%",
            height: "auto",
            marginTop: "10%",
            marginBottom: "0%",
          }}
          src="./img/earth.png"
        />
        <div
          style={{
            width: "100%",
            height: "100%",
            marginTop: "0%",
            marginBottom: "10%",
            background:
              "radial-gradient(39.08% 39.02% at 53.03% 53.71%, #FFFFFF 0%, #A4A4A4 17%, #575757 31%, #333333 43%, #181818 58%, #0B0B0B 75%, #050505 87%, #000000 100%)",
            backgroundBlendMode: "screen",
            mixBlendMode: "screen",
            opacity: 0.3,
            transform: "translate(0%, -62%) rotate(-90deg)",
          }}
        />
      </Grid>
      <div
        style={{
          position: "absolute",
          left: "20%",
          right: "20%",
          top: "40%",
          transform: "translate(0, -40%)",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: "Poppins",
            fontSize: { md: "52px", sm: "30px", xs: "40px" },
            lineHeight: { md: "75px", sm: "40px" },
            fontStyle:'normal',
            mt: 4,
            maxWidth: "800px",
          }}
        >
          MDTP is the Homepage of the Metaverse!🔮
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontFamily: "Poppins",
            fontSize: { sm: "16px", xs: "20px" },
            lineHeight: "24px",
            letter: "1%",
            mt: 2,
            maxWidth: "800px",
          }}
        >
          Show off your NFTs on space that you own as an NFT 😎 Its with crypto
          rocket-fuel 🚀
        </Typography>
        <Box sx={{ flexGrow: { lg: 1 } }}>
          <Button
            variant="contained"
            size="large"
            sx={{ my: 2, px: 2, borderRadius: "20px" }}
          >
            Purchase tokens
          </Button>
        </Box>
      </div>
    </Grid>
    </>
  );
}
